import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import "./styles.scss";

export const RadioGroup = ({
  children,
  className,
  defaultValue,
  disabled,
  name,
  onChange,
  value,
  ...props
}) => {
  const [currentValue, setCurrentValue] = useState(value ? value : defaultValue);

  useEffect(() => {
    setCurrentValue(value ? value : defaultValue);
  }, [value, defaultValue]);

  const clickHandler = (e) => {
    setCurrentValue(e.target.value);
  };

  return (
    <div className={createClassNameString(["apti-RadioGroup", className])} {...props}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          checked:
            child.props.value === currentValue ||
            (value === "" && child.props.value === defaultValue),
          disabled: disabled,
          name: name,
          onChange,
          onClick: clickHandler,
        }),
      )}
    </div>
  );
};

RadioGroup.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  value: PropTypes.string,
};

RadioGroup.defaultProps = {
  checked: false,
  disabled: false,
  label: undefined,
  name: "",
  onClick: () => {},
  value: "",
};
